import React from "react";
import { t } from "../../../../utils/i18n";

const TransferStatus = ({ transfer }) => {
  const getIncompleteTransferStatus = (transfer) => {
    const { is_complete, is_confirmed, is_unconfirmed, is_failed, is_expired } =
      transfer;

    if (
      !is_complete &&
      (!is_confirmed || is_unconfirmed) &&
      !is_failed &&
      !is_expired
    ) {
      return (
        <a
          href="#"
          data-toggle="tooltip"
          className={transfer.active_class_by_status}
          title={t("account.activities.pending_confirmation")}
        >
          <span>
            <i className="fa fa-info-circle"></i>
          </span>
        </a>
      );
    }

    return <></>;
  };

  if (transfer.is_expired) {
    return (
      <a href={`/crypto_transfers/${transfer.id}`} className="unlink">
        {t("account.activities.expired")}
      </a>
    );
  } else {
    return (
      <>
        {transfer.external_status} {getIncompleteTransferStatus(transfer)}
      </>
    );
  }
};

export default TransferStatus;
